/* ========================================================================
 * DOM-based Routing
 * Based on http://goo.gl/EUTi53 by Paul Irish
 *
 * Only fires on body classes that match. If a body class contains a dash,
 * replace the dash with an underscore when adding it to the object below.
 *
 * .noConflict()
 * The routing is enclosed within an anonymous function so that you can
 * always reference jQuery with $, even when in .noConflict() mode.
 * ======================================================================== */

( function( app ) {
  const COMPONENT = {
    init: function() {
      $( '.mpf-start' ).on( 'click', function( event ) {
        $( '.ll-mpf__main' ).removeClass( 'is-start' );
        $( '.ll-mpf__start' ).fadeToggle();
      } );

      $( document ).on( 'gform_page_loaded', function( event, formId, currentPage ) {
        const group = $( '.llgq-current-page' ).find( '.gfield_radio, .gfield_checkbox' );

        if ( group.length ) {
          group.each( function( index, element ) {
            const choices = $( element ).find( '.gchoice' );
            let tallButton = 0;
            choices.each( function( index, element ) {
              const height = $( element ).outerHeight();
              if ( height > tallButton ) {
                tallButton = height;
              }
            } );
            $( element ).css( '--choiceHeight', `${tallButton}px` );
          } );
        }
      } );
    },

    finalize: function() {
    },
  };

  app.registerComponent( 'll-mpf', COMPONENT );
} )( app );
